module.exports = __webpack_public_path__ + "static/img/bk.7e2294d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wheel/bk.png
// module id = Ec3s
// module chunks = 0